module.exports = __webpack_public_path__ + "static/media/training-bot.638ed426.svg";